@if ({ courses: courses$ | async }; as vm) {
  <nav class="nav">
    <div id="logo"><span [inlineSVG]="appConfig.logo.light"></span></div>
    @if ((currentMap$ | async)?.map_type !== MapType.Country) {
      <span class="course-name">{{ (schoolCoursesService.getCourse() | async)?.display_name }}</span>
    }
    @if ((currentMap$ | async)?.map_type === MapType.Country) {
      <lsc-course-switcher class="mobile"></lsc-course-switcher>
    }
    <div class="navigation desktop">
      <lsc-lang-switcher></lsc-lang-switcher>
      @if (vm.courses?.courses.length > 0) {
        <a (click)="navigateTo('chapters')">
          {{ 'navigation.chapters' | transloco }}
        </a>
      }
      @if (vm.courses?.courses.length > 0) {
        <a (click)="navigateTo('dictionary')">
          {{ 'navigation.my_dictionary' | transloco }}
        </a>
      }
      <button class="btn basic h-sm" (click)="handlePrivateLessonClick()">
        {{ 'navigation.private_lesson' | transloco }}
      </button>
      <div class="profile" (appClickOutside)="profileOpened = false" (click)="profileOpened = !profileOpened">
        @if (me$ | async; as me) {
          <lib-profile-circle-img class="profile-img" [image]="me.photo"></lib-profile-circle-img>
        }
      </div>
    </div>
    <div class="hamburger mobile" (click)="overlay.toggle()">
      @if (overlay.isOpened) {
        <span inlineSVG="/icons/icon-x-rounded-corners.svg"></span>
      }
      @if (!overlay.isOpened) {
        <span inlineSVG="/icons/icon-hamburger-no-color.svg"></span>
      }
    </div>
  </nav>
  <ul class="profile-list" [ngClass]="{ opened: profileOpened }">
    <li>
      <a (click)="navigateTo('profile')">
        {{ 'navigation.my_profile' | transloco }}
      </a>
    </li>
    <li>
      <a (click)="navigateTo('subscriptions')">
        {{ 'navigation.subscriptions' | transloco }}
      </a>
    </li>
    <li (click)="navigateTo('faq')">
      <a (click)="navigateTo('faq')">
        {{ 'navigation.FAQ' | transloco }}
      </a>
    </li>
    <li (click)="handleLogout()">{{ 'navigation.log_out' | transloco }}</li>
  </ul>
  <lib-mobile-overlay #overlay [heightOffset]="74">
    <div class="mobile-navigation">
      <ul>
        @if (vm.courses?.courses.length > 0) {
          <li>
            <a (click)="navigateTo('chapters')">
              {{ 'navigation.chapters' | transloco }}
            </a>
          </li>
        }
        @if (vm.courses?.courses.length > 0) {
          <li>
            <a (click)="navigateTo('dictionary')">
              {{ 'navigation.my_dictionary' | transloco }}
            </a>
          </li>
        }
        <li>
          <a (click)="navigateTo('profile')">
            {{ 'navigation.my_profile' | transloco }}
          </a>
        </li>
        <li>
          <a (click)="navigateTo('subscriptions')">
            {{ 'navigation.subscriptions' | transloco }}
          </a>
        </li>
        <li>
          <a (click)="navigateTo('faq')">
            {{ 'navigation.FAQ' | transloco }}
          </a>
        </li>
        <li>
          <a (click)="handleLogout()">
            {{ 'navigation.log_out' | transloco }}
          </a>
        </li>
        <li><lsc-lang-switcher></lsc-lang-switcher></li>
      </ul>
      <div class="mobile-bottom">
        <p>{{ 'navigation.more_knowledge' | transloco }}</p>
        <p>{{ 'navigation.apply_for_private' | transloco }}</p>
        <button (click)="handlePrivateLessonClick()" class="btn basic h-md">
          {{ 'navigation.private_lesson' | transloco }}
        </button>
      </div>
    </div>
  </lib-mobile-overlay>
}
